import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  isPromptObject,
  ObjectState,
} from '../../../../cross-team-shared/annotation/shared/state/object-state';
import { AnnotationSharedModule } from '../../../../outputs/annotation/annotation-shared/annotation-shared.module';
import { getNumericSharedCssProperty } from '../../../../outputs/annotation/annotation-shared/properties-shared-with-css';
import { SidePanelDisplayService } from '../../../../outputs/annotation/annotation-shared/side-panel/side-panel-display.service';
import { AnnotationListService } from '../../../../outputs/annotation/annotation-shared/toolbars/shape-list-and-tag-editor/annotation-list/annotation-list.service';
import { ObjectDragAndDropService } from '../../../../outputs/annotation/annotation-shared/toolbars/shape-list-and-tag-editor/annotation-list/object-drag-and-drop.service';
import { outputInfoStoreToken } from '../../../h3ml/state/output-info';
import {
  fusionStoreToken,
  TaskWorkspaceStore,
} from '../../../h3ml/state/task-workspace-store';
import {
  mockGenAiOutputId,
  mockGenAiOutputName,
} from '../../../http/loading/project-loading.service';
import { FusionManager } from '../../../outputs/annotation/annotation-shared/fusion/fusion-manager';
import { FusionManagerFactory } from '../../../outputs/annotation/annotation-shared/fusion/fusion-manager-factory.service';
import { UndoService } from '../../../outputs/annotation/annotation-shared/toolbars/static-toolbar/undo.service';
import { SelectionService } from '../../../outputs/annotation/annotation-shared/utils/selection.service';
import { ShapeSelectionService } from '../../../outputs/annotation/annotation-shared/utils/shape-selection.service';
import { AttributeContextMenuService } from '../../../shared/context-menu/attribute-context-menu.service';
import { ContextMenuService } from '../../../shared/context-menu/context-menu.service';
import { FeedbackListService } from '../../../shared/feedback/feedback-list.service';
import { FloatingPanelService } from '../../../shared/misc-services/floating-panel.service';
import { ObjectSortingService } from '../../../shared/misc-services/object-sorting.service';
import { RootUndoService } from '../../../shared/misc-services/root-undo.service';
import { HighlightFeedbackPanelService } from '../../services/highlight-feedback-panel.service';
import { HighlightMenuService } from '../../services/highlight-menu.service';
import { HighlightService } from '../../services/highlight.service';
import { GenAiToolbarComponent } from '../gen-ai-toolbar/gen-ai-toolbar.component';
import { PromptComponent } from '../prompt/prompt.component';

@Component({
  selector: 'h3-gen-ai-container',
  templateUrl: './gen-ai-container.component.html',
  styleUrl: './gen-ai-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    AnnotationSharedModule,
    PromptComponent,
    GenAiToolbarComponent,
  ],
  providers: [
    {
      provide: FusionManager,
      useFactory: () =>
        inject(FusionManagerFactory).getManager(mockGenAiOutputId),
    },
    {
      provide: fusionStoreToken,
      useFactory: () => inject(FusionManager).fusionStore,
    },
    {
      provide: outputInfoStoreToken,
      useFactory: () =>
        inject(TaskWorkspaceStore)('outputInfoByName')(mockGenAiOutputName),
    },
    {
      provide: UndoService,
      useExisting: RootUndoService,
    },
    AnnotationListService,
    AttributeContextMenuService,
    ContextMenuService,
    HighlightFeedbackPanelService,
    FeedbackListService,
    FloatingPanelService,
    HighlightMenuService,
    HighlightService,
    ObjectDragAndDropService,
    SelectionService,
    ShapeSelectionService,
    SidePanelDisplayService,
  ],
})
export class GenAiContainerComponent {
  private readonly objectSortingService = inject(ObjectSortingService);
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);

  objectListWidth = getNumericSharedCssProperty('object-list-width');
  sortedPrompts: ObjectState[];
  toolbarHeight = getNumericSharedCssProperty('split-view-toolbar-height');
  scrollbarWidth = getNumericSharedCssProperty('scrollbar-width');

  constructor() {
    this.taskWorkspaceStore('selectedOutputName').set(mockGenAiOutputName);

    const rootLevelObjects =
      this.objectSortingService.getSortedObjects(undefined);

    this.sortedPrompts = rootLevelObjects.filter(isPromptObject);
  }
}
